<template>
  <span :class="{'goal': isClassActive}">{{score}}</span>
</template>

<script>

export default {
  props: {
    score: {
      score: Number,
      required: true
    }
  },
  data () {
    return {
      timerInterval: 1000,
      isClassActive: false,
      timer: null,
      timerCounter: 0
    }
  },
  watch: {
    score: function (val, old) {
      if (Math.abs(val - old) === 1) {
        this.clearTimer()
        this.startTimer()
      }
    }
  },
  methods: {
    timerCallback () {
      this.timerCounter++
      if (this.timerCounter > 6) {
        this.clearTimer()
        return
      }
      this.isClassActive = !((this.timerCounter % 2) === 0)
    },
    startTimer () {
      if (this.score > 0) {
        if (this.timer) {
          this.clearTimer()
        }
        this.timer = setInterval(this.timerCallback, this.timerInterval)
      }
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
        this.timerCounter = 0
      }
    }
  },
  mounted () {
    this.startTimer()
  },
  beforeDestroy () {
    this.clearTimer()
  }
}
</script>

<style scoped>
</style>
